// Constantes del módulo Provider Documentation Coach (Módulo F — BillingV2).

/** Estados de revisión de una nota con hallazgos. */
export const NOTE_STATUS = {
  OPEN: "open",
  COACHED: "coached",
  ACKNOWLEDGED: "acknowledged",
};

export const NOTE_STATUS_META = {
  [NOTE_STATUS.OPEN]: { tone: "warn", label: "Pending review" },
  [NOTE_STATUS.COACHED]: { tone: "info", label: "Coaching sent" },
  [NOTE_STATUS.ACKNOWLEDGED]: { tone: "ok", label: "Acknowledged" },
};

/** Tipos de hallazgo de documentación. */
export const ISSUE_TYPES = {
  MISSING_MEAT: "missing_meat",
  UNSPECIFIED_CODE: "unspecified_code",
  MISSING_LINKAGE: "missing_linkage",
};

export const ISSUE_TYPE_LABELS = {
  [ISSUE_TYPES.MISSING_MEAT]: "Missing MEAT",
  [ISSUE_TYPES.UNSPECIFIED_CODE]: "Unspecified code",
  [ISSUE_TYPES.MISSING_LINKAGE]: "Missing linkage",
};

/** Severidad de hallazgo → tono semántico. */
export const ISSUE_SEVERITY_META = {
  high: { tone: "crit", label: "High" },
  medium: { tone: "warn", label: "Medium" },
  low: { tone: "info", label: "Low" },
};
